import React from "react";
import buildDataProvider, { defaultOurOptions } from "./buildDataProvider";
import { DataProviderOptions } from "./types";
import { LegacyDataProvider } from "react-admin";
import schema from "./introspection.json";

const useDataProvider = (
  options: DataProviderOptions,
  url: string,
  accessToken?: string
) => {
  const [dataProvider, setDataProvider] = React.useState<LegacyDataProvider>();

  React.useEffect(() => {
    if (accessToken) {
      const modifiedOptions = {
        ...options,
        // Add or modify properties here
        introspection: {
          schema: schema["__schema"]
        }
      };
      buildDataProvider(
        { ...defaultOurOptions, ...modifiedOptions },
        url,
        accessToken
      ).then((p) => {
        setDataProvider(() => p);
      });
    }
  }, [accessToken]);

  return dataProvider;
};

export default useDataProvider;
